import { render, staticRenderFns } from "./WidgetsReportAccountNotice.vue?vue&type=template&id=863ce8ec&scoped=true"
import script from "./WidgetsReportAccountNotice.vue?vue&type=script&lang=js"
export * from "./WidgetsReportAccountNotice.vue?vue&type=script&lang=js"
import style0 from "./WidgetsReportAccountNotice.vue?vue&type=style&index=0&id=863ce8ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "863ce8ec",
  null
  
)

export default component.exports